import React from 'react';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from 'pages/Dashboard/components/Button';

type Props = {
  onChange: (value: boolean) => void;
  value?: boolean;
  labels?: string[];
  className?: string;
};

export default function TwoChoiceGroup({
  value = false,
  onChange,
  labels = ['Yes', 'No'],
  className,
}: Props) {
  return (
    <ButtonGroup
      variant="contained"
      className={className}
      disableElevation
    >
      {labels.map((label, index) => (
        <Button
          key={label}
          onClick={() => { onChange(!index); }}
          color={!index === value ? 'primary' : undefined}
          variant={!index === value ? 'contained' : 'outlined'}
        >
          {label}
        </Button>
      ))}
    </ButtonGroup>
  );
}
